import { useEffect } from "react";
import { useAppData } from "../Context/AppContext";

const DEFAULT_TITLE = "Book a Meeting";
const DEFAULT_DESCRIPTION = "Web site created using create-react-app";

function setMetaTag(selector, attributes) {
    let tag = document.head.querySelector(selector);
    if (!tag) {
        tag = document.createElement("meta");
        document.head.appendChild(tag);
    }
    Object.entries(attributes).forEach(([key, value]) => tag.setAttribute(key, value));
}

export default function MetaTags() {
    const { apiData } = useAppData();

    // Always keep the page out of search indexes, even if the static tag is stripped
    useEffect(() => {
        setMetaTag('meta[name="robots"]', { name: "robots", content: "noindex, nofollow" });
    }, []);

    // Set title/description from the calendar config once the API responds
    useEffect(() => {
        if (!apiData) return;

        const name = (apiData.custom_name || apiData.user?.name || "").trim();
        const title = name ? `${name} — Book a Meeting` : DEFAULT_TITLE;
        const description = (apiData.description || "").trim() || DEFAULT_DESCRIPTION;

        document.title = title;
        setMetaTag('meta[name="description"]', { name: "description", content: description });
        setMetaTag('meta[property="og:title"]', { property: "og:title", content: title });
        setMetaTag('meta[property="og:description"]', { property: "og:description", content: description });
    }, [apiData]);

    return null;
}
